import React, { useEffect, useState } from "react";
import {
  IconButton,
  Link as LinkMui,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ContentBox from "../../../ContentBox/ContentBox";
import ApiClient from "../../../../services/ApiClient";
import { Delete } from "@mui/icons-material";
import dayjs from "dayjs";
import { BeaRetry } from "../../../../types/BeaRetry";
import { useBackofficeUser } from "../../../../provider/BackofficeUserProvider";
import LegalbirdIoConfirm from "../../../Modal/LegalbirdIoConfirm";
import { Link } from "react-router-dom";
import { getCaseLinkByBackofficeCase } from "../../../../services/Product/ProductService/productService";

export default function ActiveBeaRetries() {
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
  const [retryToDelete, setRetryToDelete] = useState<BeaRetry | null>(null);
  const [activeBeaRetries, setActiveBeaRetries] = useState<BeaRetry[]>([]);
  const { backofficeUsers } = useBackofficeUser();

  const fetchRetries = async () => {
    const beaRetriesResult = await ApiClient.get("bea_retries?success=false&deleted=false");
    setActiveBeaRetries(beaRetriesResult["hydra:member"]);
  };

  useEffect(() => {
    fetchRetries();
  }, []);

  const deleteRetry = async (beaRetry: BeaRetry) => {
    await ApiClient.patch(beaRetry["@id"], {
      body: JSON.stringify({
        deleted: true,
      }),
    });
    fetchRetries();
  };

  return (
    <>
      <ContentBox headline="beA-Retries">
        <Typography>
          Übersicht über alle aktiven beA-Retries. Diese werden stündlich um XX:41 Uhr versucht neu zu versenden. Mit
          einem Klick auf das Löschicon können diese dauerhaft entfernt werden. Wichtig: Es wird dann keine weiteren
          Versandversuche geben.
        </Typography>
        <Table sx={{ tableLayout: "fixed", wordWrap: "break-word" }}>
          <TableHead>
            <TableRow>
              <TableCell>Datum</TableCell>
              <TableCell>Fall</TableCell>
              <TableCell>Anwalt</TableCell>
              <TableCell>Betreff</TableCell>
              <TableCell sx={{ width: "380px" }}>Fehler</TableCell>
              <TableCell sx={{ width: "90px" }}>Retry-Versuch</TableCell>
              <TableCell sx={{ width: "90px" }}>Löschen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!activeBeaRetries.length ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  Kein aktiver beA-Retry vorhanden
                </TableCell>
              </TableRow>
            ) : (
              activeBeaRetries.map((beaRetry, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{dayjs(beaRetry.created).format("DD.MM.YYYY, HH:mm [Uhr]")}</TableCell>
                    <TableCell>
                      {beaRetry.backofficeCase && (
                        <LinkMui
                          component={Link}
                          to={getCaseLinkByBackofficeCase(beaRetry.backofficeCase)}
                          target={"_blank"}
                        >
                          {beaRetry.backofficeCase.label}
                        </LinkMui>
                      )}
                    </TableCell>
                    <TableCell>
                      {
                        backofficeUsers.find(
                          (BackofficeUser) => BackofficeUser.id === beaRetry.requestData.sendingLawyerId
                        )?.person?.fullname
                      }
                    </TableCell>
                    <TableCell>{beaRetry.requestData.subject}</TableCell>
                    <TableCell>{beaRetry.requestData.lastErrorMessage}</TableCell>
                    <TableCell>{beaRetry.requestData.retryAttempts}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setRetryToDelete(beaRetry);
                          setOpenConfirmDeleteModal(true);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </ContentBox>
      <LegalbirdIoConfirm
        open={openConfirmDeleteModal}
        handleClose={() => {
          setOpenConfirmDeleteModal(false);
          setRetryToDelete(null);
        }}
        headline={"Retry löschen"}
        content="Soll der beA-Retry wirklich gelöscht werden?"
        confirmText="Löschen"
        handleConfirm={async () => {
          if (!retryToDelete) {
            return;
          }

          await deleteRetry(retryToDelete);
        }}
      />
    </>
  );
}
